import "./style.css";
import React from "react";
import { Helmet } from "react-helmet";

import OreraChatImage from "assets/projects/orera-chat.png";
import OnlinePremedImage from "assets/projects/online-premed.png";
import AETasksImage from "assets/projects/ae-tasks.png";
import DadJokesImage from "assets/projects/dad-jokes.png";

import {
	faAndroid,
	faGithub,
	faUbuntu,
	faWindows,
} from "@fortawesome/free-brands-svg-icons";
import {
	faDatabase,
	faGlobe,
	faLaptopCode,
	faServer,
	faTerminal,
} from "@fortawesome/free-solid-svg-icons";

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCards } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-cards";

import Article from "components/Article";
import Card from "components/Card";
import Container from "components/Container";
import Hero from "components/Hero";
import TextBox from "components/TextBox";
import ExpandableCard from "components/ExpandableCard/Index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Footer from "components/Footer";

export default function Home() {
	return (
		<React.Fragment>
			<Helmet>
				<title>Abrahams portfolio | Hem</title>
			</Helmet>
			<Container>
				<Hero />
				<Article articleClass="experience-container">
					<TextBox
						textContainerClass="experience-info-container"
						textClass="experience-info-text-class"
						text="Mina färdigheter"
					/>
					<Container
						containerId="icons"
						containerClass="icons-container"
					>
						<FontAwesomeIcon
							id="laptopCodeIcon"
							icon={faLaptopCode}
							className="experience-icon"
							title="Programmeringskunskaper"
						/>
						<FontAwesomeIcon
							id="serverIcon"
							icon={faServer}
							className="experience-icon"
							title="Serverkunskaper"
						/>
						<FontAwesomeIcon
							id="terminalIcon"
							icon={faTerminal}
							className="experience-icon"
							title="Terminalkunskaper"
						/>
						<TextBox
							textId="apiIcon"
							text="API"
							textClass="experience-icon"
							textTitle="API kunskaper"
						/>
					</Container>
					<Container
						containerId="swiperContainer"
						containerClass="swiper-container swiper-skill-card"
					>
						<Container
							containerId="skillTop"
							containerClass="skill-tablet-flex"
						>
							<Container containerId="devlopSwiper">
								<Swiper
									className="mySwiper experience-swiper"
									effect={"cards"}
									modules={[EffectCards]}
									rewind={true}
								>
									<SwiperSlide>
										<Card
											cardId="androidExperience"
											cardContainerClass="experience-card-container"
											cardTitleContainerClass="experience-card-title-container"
											cardTitleIconClass="experience-card-icon"
											cardTitleIcon={faAndroid}
											cardTitleClass="experience-card-title"
											cardTitle="Android-utveckling"
											cardBodyClass="experience-card-body"
											cardBody="Jag har både arbetat med Kotlin samt även suttit med det själv i egna projekt. Jag har också självmant lärt mig Xamarin, som nu mera heter .NET MAUI. Utöver detta så har jag även erfarenhet av apache cordova från mitt examensarbete."
										/>
									</SwiperSlide>
									<SwiperSlide>
										<Card
											cardId="webExperience"
											cardContainerClass="experience-card-container"
											cardTitleContainerClass="experience-card-title-container"
											cardTitleIconClass="experience-card-icon"
											cardTitleIcon={faGlobe}
											cardTitleClass="experience-card-title"
											cardTitle="Webbutveckling"
											cardBodyClass="experience-card-body"
											cardBody="Jag har erfarenhet i ASP.NET Core, Gatsby, ReactJS, VueJS, jQuery samt HTML, CSS och JavaScript. Min erfarenhet av webbutveckling kommer från arbetslivet, utbildning och mina egna projekt. Jag har även erfarenhet av CSS ramverk som Bootstrap och Tailwind."
										/>
									</SwiperSlide>
									<SwiperSlide>
										<Card
											cardId="databaseExperience"
											cardContainerClass="experience-card-container"
											cardTitleContainerClass="experience-card-title-container"
											cardTitleIconClass="experience-card-icon"
											cardTitleIcon={faDatabase}
											cardTitleClass="experience-card-title"
											cardTitle="Databasutveckling"
											cardBodyClass="experience-card-body"
											cardBody="Jag har arbetat med databaser som Microsoft SQL Server, SQLite och Firebase. Min erfarenhet av SQL Server kommer från både utbildning och arbetslivet. I mina egna projekt har jag använt mig av antingen SQLite eller Firebase."
										/>
									</SwiperSlide>
									<SwiperSlide>
										<Card
											cardId="sharePointExperience"
											cardContainerClass="experience-card-container"
											cardTitleContainerClass="experience-card-title-container"
											cardTitleClass="experience-card-title"
											cardTitle="SharePoint"
											cardBodyClass="experience-card-body"
											cardBody="Jag har i ett av mina uppdrag arbetat med en kunds intranät i SharePoint. Jag var med i ett mindre team och byggde upp sidan från grunden. Vi flyttade över data från deras gamla intranät, fixade roller som vi kopplade till olika grupper och byggde eget tema"
										/>
									</SwiperSlide>
								</Swiper>
							</Container>
							<Container containerId="serverSwiper">
								<Swiper
									className="mySwiper experience-swiper"
									effect={"cards"}
									modules={[EffectCards]}
									rewind={true}
								>
									<SwiperSlide>
										<Card
											cardId="windowsServerExperience"
											cardContainerClass="experience-card-container"
											cardTitleContainerClass="experience-card-title-container"
											cardTitleIconClass="experience-card-icon"
											cardTitleIcon={faWindows}
											cardTitleClass="experience-card-title"
											cardTitle="Windows server"
											cardBodyClass="experience-card-body"
											cardBody="Jag har erfarenhet av Windows server från både arbetslivet och utbildning. I mina tidigare uppdrag har jag både satt upp en Windows Server miljö samt konfigurerat IIS:en. Jag har även arbetat med felsökning i kundernas server miljöer."
										/>
									</SwiperSlide>
									<SwiperSlide>
										<Card
											cardId="ubuntuServerExperience"
											cardContainerClass="experience-card-container"
											cardTitleContainerClass="experience-card-title-container"
											cardTitleIconClass="experience-card-icon"
											cardTitleIcon={faUbuntu}
											cardTitleClass="experience-card-title"
											cardTitle="Ubuntu server"
											cardBodyClass="experience-card-body"
											cardBody="Jag har självmant lärt mig att sätta upp och konfigurera en Ubuntu Server med apache. Jag har även testat att sätta upp en hemsida på min server och fått den att fungera. Mina kunskaper är grundläggande men jag har viljan att lära mig mer."
										/>
									</SwiperSlide>
								</Swiper>
							</Container>
						</Container>
						<Container
							containerId="skillBottom"
							containerClass="skill-tablet-flex"
						>
							<Container containerId="terminalSwiper">
								<Swiper
									className="mySwiper experience-swiper"
									effect={"cards"}
									modules={[EffectCards]}
									rewind={true}
								>
									<SwiperSlide>
										<Card
											cardId="bashTerminal"
											cardContainerClass="experience-card-container"
											cardTitleContainerClass="experience-card-title-container"
											cardTitleIconClass="experience-card-icon"
											cardTitleIcon={faUbuntu}
											cardTitleClass="experience-card-title"
											cardTitle="Bash Terminal"
											cardBodyClass="experience-card-body"
											cardBody="Då jag kör linux som operativsystem på min dator så är bash en del av min vardag. Den används till nästan allt från mina GitHub kommandon till att ändra filer i systemet. Jag har självmant lärt mig att använda bash och dess kommandon."
										/>
									</SwiperSlide>
									<SwiperSlide>
										<Card
											cardId="gitBash"
											cardContainerClass="experience-card-container"
											cardTitleContainerClass="experience-card-title-container"
											cardTitleIconClass="experience-card-icon"
											cardTitleIcon={faGithub}
											cardTitleClass="experience-card-title"
											cardTitle="Git Bash"
											cardBodyClass="experience-card-body"
											cardBody="Jag har i många Git projekt använt mig av Git bash terminalen. Det är ett snabbt sätt att committa, göra en pull och merga ihop branches. Ibland kan det dock kännas lite nervöst att använda vissa kommandon, speciellt när man inte använt de innan."
										/>
									</SwiperSlide>
									<SwiperSlide>
										<Card
											cardId="windowsPowershell"
											cardContainerClass="experience-card-container"
											cardTitleContainerClass="experience-card-title-container"
											cardTitleIconClass="experience-card-icon"
											cardTitleIcon={faWindows}
											cardTitleClass="experience-card-title"
											cardTitle="PowerShell"
											cardBodyClass="experience-card-body"
											cardBody="Jag har använt mig av PowerShell för att skapa installationsskript och för att arbeta med SharePoint. Installationsskripten användes för att installera windows features på kundernas server miljöer och för SharePoint användes PowerShell för att hantera roller och lägga till teman."
										/>
									</SwiperSlide>
								</Swiper>
							</Container>
							<Container containerId="apiSwiper">
								<Swiper
									className="mySwiper experience-swiper"
									effect={"cards"}
									modules={[EffectCards]}
									rewind={true}
								>
									<SwiperSlide>
										<Card
											cardId="soapApi"
											cardContainerClass="experience-card-container"
											cardTitleContainerClass="experience-card-title-container"
											cardTitleClass="experience-card-title"
											cardTitle="soap api"
											cardBodyClass="experience-card-body"
											cardBody="I ett av mina tidigare uppdrag fick jag chansen att lära mig att anropa SOAP API:er. Det var till en kund som hanterade bankfiler och uppdraget handlade om att hämta information, formatera den korrekt och lagra den i en bankfil."
										/>
									</SwiperSlide>
									<SwiperSlide>
										<Card
											cardId="restApi"
											cardContainerClass="experience-card-container"
											cardTitleContainerClass="experience-card-title-container"
											cardTitleClass="experience-card-title"
											cardTitle="rest api"
											cardBodyClass="experience-card-body"
											cardBody="Jag har erfarenhet av att både utveckla och anropa REST API:er. Erfarenheten kommer från både arbetslivet och egna projekt, där jag har arbetat med API:er i både C# och JavaScript. Jag har även självmant lärt mig att använda NodeJS för att skapa API:er."
										/>
									</SwiperSlide>
								</Swiper>
							</Container>
						</Container>
					</Container>
				</Article>
				<Article articleClass="work-experience-container">
					<TextBox
						textContainerClass="work-experience-info-container"
						textClass="work-experience-info-text-class"
						text="arbetslivserfarenhet"
					/>
					<Container containerClass="work-expandable-card-container">
						<Container containerId="first">
							<ExpandableCard
								expCardId="amaceit"
								expCardTopId="amaceitTop"
								expCardContClass="expandable-container"
								expCardTopClass="expandable-card-top-class"
								expCardIconClass="expandable-icon"
								expCardTitleClass="expandable-title"
								expCardTitleText="amaceit AB"
								expCardInfoClass="expandable-info"
								expCardInfoText="Jan 2023 - Mar 2025"
								expCardBodyClass="expandable-body"
								expCardBodyText="Jag arbetade på amaceit som IT-Konsult. Jag har i min roll fått
							arbeta med olika typer av projekt, inom webbutveckling och
							mobilutveckling. Inom webbutveckling har jag fått möjligheten att
							arbeta med projekt i SharePoint, React och Umbraco CMS. Inom
							mobilutveckling så har jag arbetat med ett projekt i Kotlin"
							/>
							<ExpandableCard
								expCardId="formpipe"
								expCardTopId="formpipeTop"
								expCardContClass="expandable-container"
								expCardTopClass="expandable-card-top-class"
								expCardIconClass="expandable-icon"
								expCardTitleClass="expandable-title"
								expCardTitleText="Formpipe"
								expCardInfoClass="expandable-info"
								expCardInfoText="Jan 2022 - Dec 2022"
								expCardBodyClass="expandable-body"
								expCardBodyText="Jag arbetade på Formpipe som lösningskonsult. Mina arbetsuppgifter
							bestod av att skapa en koppling mellan användarens behov och krav.
							Jag har kongurerat servrar, hjälpt till med uppgraderingar och
							installerat webbapplikationer. Jag har även arbetat med
							kundspecika anpassningar"
							/>
						</Container>
						<Container containerId="second">
							<ExpandableCard
								expCardId="preuni"
								expCardTopId="preuniTop"
								expCardContClass="expandable-container"
								expCardTopClass="expandable-card-top-class"
								expCardIconClass="expandable-icon"
								expCardTitleClass="expandable-title"
								expCardTitleText="Pre-Uni"
								expCardInfoClass="expandable-info"
								expCardInfoText="Jul 2021 - Dec 2021"
								expCardBodyClass="expandable-body"
								expCardBodyText="Jag arbetade med webbsidan och Pre-Uni produkten Online Premed.
							Mitt arbete bestod av att ta fram en design som både är estetiskt
							tilltalande och användarvänlig samt även utveckla produkten för
							Online Premed. Produkten är anpassad för personer som vill studera
							medicin men som inte har betygen som krävs. Den förbereder dom
							inför intagningsprovet som diverse universitet i EU har för att ta emot
							studerande"
							/>
							<ExpandableCard
								expCardId="ucs"
								expCardTopId="ucsTop"
								expCardContClass="expandable-container"
								expCardTopClass="expandable-card-top-class"
								expCardIconClass="expandable-icon"
								expCardTitleClass="expandable-title"
								expCardTitleText="ucs it solutions"
								expCardInfoClass="expandable-info"
								expCardInfoText="Mar 2021 - Jun 2021"
								expCardBodyClass="expandable-body"
								expCardBodyText="Jag utförde min andra LIA på UCS IT Solutions där jag arbetade agilt
							med ett projekt i VueJs, Typescript och Laravel PHP"
							/>
						</Container>
						<Container containerId="third">
							<ExpandableCard
								expCardId="redcapes"
								expCardTopId="redcapesTop"
								expCardContClass="expandable-container"
								expCardTopClass="expandable-card-top-class"
								expCardIconClass="expandable-icon"
								expCardTitleClass="expandable-title"
								expCardTitleText="Redcapes"
								expCardInfoClass="expandable-info"
								expCardInfoText="Mar 2020 - Jun 2020"
								expCardBodyClass="expandable-body"
								expCardBodyText="Jag utförde min första LIA på Redcapes där jag arbetade agilt med ett
							eget projekt i ASP .Net Core MVC och SQL Server"
							/>
							<ExpandableCard
								expCardId="telenor"
								expCardTopId="telenorTop"
								expCardContClass="expandable-container"
								expCardTopClass="expandable-card-top-class"
								expCardIconClass="expandable-icon"
								expCardTitleClass="expandable-title"
								expCardTitleText="Telenor"
								expCardInfoClass="expandable-info"
								expCardInfoText="Jul 2016 - Aug 2020"
								expCardBodyClass="expandable-body"
								expCardBodyText="Jag arbetade som butikssäljare på Telenor i Linköping som både fast
							och extraanställd. Min arbetsuppgift var att erbjuda en professionell
							service till kunder"
							/>
						</Container>
					</Container>
				</Article>
				<Article articleClass="project-container">
					<TextBox
						textContainerClass="experience-info-container"
						textClass="experience-info-text-class"
						text="Mina projekt"
					/>
					<Container containerClass="project-expandable-card-container">
						<Container containerClass="card-tablet-flex">
							<ExpandableCard
								expCardContClass="project-card-container"
								expCardTopClass="project-card-top-container"
								expCardTitleClass="project-card-title-class"
								expCardTitleText="orera chat"
								expCardImageClass="project-card-image"
								expCardImageSrc={OreraChatImage}
								expCardGitLink="https://github.com/Abrei852/Orera-Chat"
								expCardWebLink="https://orera-chat.netlify.app/#/"
								expCardCodeLangClass="project-card-code-language"
								expCardCodeLang="vue firebase webrtc"
								expCardBodyClass="project-body-class"
								expCardBodyText="En chattapplikation för studenter där användare både kan chatta genom text och genom videosamtal."
							/>
							<ExpandableCard
								expCardContClass="project-card-container"
								expCardTopClass="project-card-top-container"
								expCardTitleClass="project-card-title-class"
								expCardTitleText="onlinepremed"
								expCardImageClass="project-card-image"
								expCardImageSrc={OnlinePremedImage}
								expCardWebLink="https://www.onlinepremed.com/"
								expCardCodeLangClass="project-card-code-language"
								expCardCodeLang="html css javascript Kajabi"
								expCardBodyClass="project-body-class"
								expCardBodyText="En tjänst som erbjuds till framtida studenter inom medicin, tandläkare, veterinär, apotekare och sköterska. Jag har både skapat och tagit fram designen samt även arbetat med produktutveckling."
							/>
						</Container>
						<Container containerClass="card-tablet-flex">
							<ExpandableCard
								expCardContClass="project-card-container"
								expCardTopClass="project-card-top-container"
								expCardTitleClass="project-card-title-class"
								expCardTitleText="Simple task app"
								expCardImageClass="project-card-image"
								expCardImageSrc={AETasksImage}
								expCardGitLink="https://github.com/Abrei852/AETask"
								expCardCodeLangClass="project-card-code-language"
								expCardCodeLang="android kotlin jetpack-compose Room"
								expCardBodyClass="project-body-class"
								expCardBodyText="En enkel tasks applikation för att kunna lägga till, ta bort och visa tasks. Applikationen är byggd med jetpack compose och använder room databas för att hantera data."
							/>
							<ExpandableCard
								expCardContClass="project-card-container"
								expCardTopClass="project-card-top-container"
								expCardTitleClass="project-card-title-class"
								expCardTitleText="dad jokes search"
								expCardImageClass="project-card-image"
								expCardImageSrc={DadJokesImage}
								expCardGitLink="https://github.com/Abrei852/dad-jokes-search"
								expCardCodeLangClass="project-card-code-language"
								expCardCodeLang="html css jsx react"
								expCardBodyClass="project-body-class"
								expCardBodyText="En enkel applikation som använder dad jokes api för att hämta dad jokes, går att söka efter dad jokes också."
							/>
						</Container>
					</Container>
				</Article>
				<Footer />
			</Container>
		</React.Fragment>
	);
}
